import { HomepageOrderEditor } from "../HomepageOrderEditor"

interface HomepageTabProps {
  geo: string
}

export const HomepageTab = ({ geo }: HomepageTabProps) => {
  return <HomepageOrderEditor geo={geo} />
}
